import React, { useContext, useState, Fragment } from 'react';
import { withStyles } from '@material-ui/core';
import DataContext from '../../data/DataContext';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  leftContainer: {
    justifyContent: 'flex-start',
    marginBottom: '0.375rem',
    // maxWidth:"75%"
  },
  rightContainer: {
    justifyContent: 'flex-end',
  },
  leftMessage: {
    // backgroundColor: "white",
    // boxShadow: "0px 12px 12px rgba(194, 194, 194, 0.58)",
    // fontWeight: "300",
  },
  rightMessage: {
    // backgroundColor: theme.color.message.background,
    // margin: "8px 10px",
    boxShadow: 'none',
  },
  message: {
    'text-size_adjust': 'auto',
    fontSize: theme.font.size15, // "15px",
    borderRadius: '0.75rem',
    flexWrap: 'wrap',
    color: theme.color.message.color,
    padding: '0.125rem 1rem 0rem 1rem',
    width: '16.25rem',
    zIndex: 10,
    wordWrap: 'break-word',
    wordBreak: 'break-word',
  },
  text: {
    padding: '0.75rem 1rem',
    lineHeight: '1.43',
    borderRadius: '0.625rem',
    backgroundColor: theme.color.message.background,
    fontFamily: 'inherit',
    fontSize: theme.font.size14, //"14px",
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000',
  },
  buttons: {
    display: 'flex',
    padding: '0rem 0.8125rem',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  buttonIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // width: "30%",
    marginRight: '0.375rem',
  },
  menuIcon: {
    width: '2.5rem',
    height: '2.5rem',
  },
  listbutton: {
    width: 'calc(50% - 0.375rem)',
    margin: '0.1875rem',
    border: '0',
    borderRadius: '0.375rem',
    boxShadow: '0 0.125rem 0.375rem 0 rgba(0, 0, 0, 0.1)',
    backgroundColor: '#fff',
    display: 'flex',
    // justifyContent: "center",
    alignItems: 'center',
    height: '4rem',
    cursor: 'pointer',
  },
  listbuttonDisabled: {
    backgroundColor: '#eee',
  },
  title: {
    padding: '0.75rem 0rem 0.375rem 0rem',
    fontFamily: 'inherit',
    fontSize: '0.9375rem',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.2',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000',
  },
  buttonLabel: {
    fontFamily: 'inherit',
    fontSize: '0.875rem',
    fontWeight: '500',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.29',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000',
    paddingRight: '0.3125rem',
    // wordBreak: "keep-all"
  },
  '@media screen and (max-width:767px)': {
    message: {
      width: '100%',
    },
  },
});

const SGButton = withStyles(styles)((props) => {
  const { classes, data } = props;
  const [buttonVisible, setButtonVisible] = useState(true);
  const context = useContext(DataContext);
  const handleClick = (button) => {
    setButtonVisible(false);
    context.request(context, button.label, 'button');
  };
  const disabledCondition = !data.isLast || context.conversationEnd;
  return (
    <div className={classes.buttons}>
      {data.buttons.map(
        (button, key) =>
          buttonVisible && (
            <button
              key={key}
              className={`${classes.listbutton}`}
              disabled={disabledCondition}
              onClick={() => handleClick(button)}
              aria-label={`${button.label}, ${key + 1} / ${data.buttons.length}`}
            >
              <div className={classes.buttonIcon}>
                {button.icon_code && (
                  <img
                    src={`/image/${button.icon_code}.svg`}
                    className={classes.menuIcon}
                    alt=""
                  />
                )}
              </div>
              <div className={classes.buttonLabel}>{button.label}</div>
            </button>
          )
      )}
    </div>
  );
});
function SGICGrid(props) {
  const { classes, data } = props;
  return (
    <Fragment>
      <div
        className={[
          classes.root,
          data.mine ? classes.rightContainer : classes.leftContainer,
        ].join(' ')}
      >
        <div
          className={[
            classes.message,
            data.mine ? classes.rightMessage : classes.leftMessage,
          ].join(' ')}
        >
          {data.text && data.text.length && (
            <div role={'text'} className={classes.text} tabIndex={0}>
              {data.text.split('\n').map((content, key) => (
                <Fragment key={key}>
                  {content}
                  <br />
                </Fragment>
              ))}
            </div>
          )}
          {data.title && data.title.length && (
            <div className={classes.title}>{data.title}</div>
          )}
        </div>
      </div>

      <SGButton data={data}></SGButton>
    </Fragment>
  );
}
export default withStyles(styles)(SGICGrid);
